import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { EnvironmentService } from '../../../app/services/environment.service';

import * as signalR from '@aspnet/signalr';
import { BannerService } from './banner.service';
import { Subject } from 'rxjs';
import { LogEntryModel } from '../../models/logentry';
import { Store } from '@ngxs/store';
import { LogEntry } from './log/log.action';
import { HelperService } from '../../services/helper/helper.service';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

constructor(  private bannerService: BannerService,
              private httpClient: HttpClient,
              private store: Store,
              private environment: EnvironmentService,
              private helper: HelperService
  ) {
}

// public notifications: any;
private hubConnection: signalR.HubConnection;

// tslint:disable: variable-name
private _notifications = new Subject<string>();
public connectionState = new Subject<string>();

public notifications = this._notifications.asObservable();
public connection_state = this.connectionState.asObservable();

public getNotificationsOnce() {
  return this.httpClient.get(`${this.environment.getApiURL()}/api/goodmorning`);
}

public startConnection = (reconnection_count?: number) => {
  const rcount = reconnection_count || 0;
  this.hubConnection = new signalR.HubConnectionBuilder()

                              .withUrl(this.environment.getApiURL() + '/notifications')
                              .build();

  this.hubConnection
        .start()
        .then(() => {
          this.connectionState.next('STARTED');
        } )
        .catch(err => {
          this.connectionState.next('CONN_ERROR');
          // this.bannerService.warning('Error while starting connection (' + rcount + ')', 'WebSocket error.' );
          this.helper.consoleLog(`WebSocket error -> Error while starting connection (${rcount})` );

        });

  this.hubConnection.onclose(() => {
          this.connectionState.next('CLOSED');
          // this.bannerService.warning('Websocket connection closed, system will try recconect.' );
          this.helper.consoleLog(`WebSocket error -> Websocket connection closed, system will try recconect.` );

        });
}

public stop() {
    this.hubConnection.stop();
}

public addNotificationsListener = () => {
      this.hubConnection.on('transfernotifications', (data) => {
        // this.helper.consoleLog('hubConnection:' + JSON.stringify(data));
        let notifs = null;
        if (this.helper.isExists(data.items) && data.success) {
          this.helper.consoleLog('WebSocketData:' + data.items.length + ' items received.');
          // this.helper.consoleLog(data);
          notifs = data.items;
        } else {
          notifs = null;

          let errorEntry = new LogEntryModel();
          // tslint:disable-next-line: max-line-length
          errorEntry =  ( {entry : 'Błąd pobierania notyfikacji', methodName: 'addNotificationsListener', type : 'error'} as LogEntryModel);
          this.store.dispatch(new LogEntry(errorEntry));
          // this.bannerService.error('Websocket connection closed, system will try recconect.', 'WebSocket error.' );
          this.helper.consoleLog(`WebSocket error -> Websocket connection closed, system will try recconect.` );

        }

        this._notifications.next(notifs);
      });
}


}
